import { EarthingSchemeLB } from '../common/enums/earthingSchemes'
import { EarthingSystem } from '../common/redux/api/web-api'

const calculateMaxPower = (maxCurrent: number, phasesCount: number, earthingScheme?: EarthingSystem | null): number =>
    (earthingScheme === EarthingSchemeLB.IT ? 1 : phasesCount) * maxCurrent * 0.23

export default calculateMaxPower
